// extracted by mini-css-extract-plugin
export default {"wrapper":"SettingsPage_wrapper__xlE3i","layout":"SettingsPage_layout__8G11p","content":"SettingsPage_content__9NyNh"};